module.exports = __webpack_public_path__ + "img/file-image-plus-outline.1ed51a19.svg";